/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IModalStyles } from '@fluentui/react/lib/Modal';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { getHTMLDir } from '../../../utilities/Utils';

export const getModalStyles = (): Partial<IModalStyles> => {
    const isRtl = getHTMLDir(getAppHost().getLocaleName()) === 'rtl';

    return {
        scrollableContent: {
            width: '600px',
            height: '600px',
            maxHeight: 'calc(100vh - 115px)',
            overflow: 'hidden',

            selectors: {
                '&>div': {
                    height: '100%',
                    width: '100%',
                },
                '.modal-dismiss-button': {
                    position: 'absolute',
                    right: isRtl ? null : '15px',
                    left: isRtl ? '15px' : null,
                    top: '22px',
                    zIndex: 20,
                },
            },
        },
    };
};
